
import React, { useState } from 'react';
import { Navbar, Nav, NavDropdown, Container } from 'react-bootstrap';
import { Link } from 'react-router-dom';

const Header = () => {
  const [isNavOpen, setIsNavOpen] = useState(false);
  const [isSearchOpen, setIsSearchOpen] = useState(false);

  const toggleNav = () => {
    setIsNavOpen(!isNavOpen);
  };

  const toggleSearch = () => {
    setIsSearchOpen(!isSearchOpen);
  };

  return (
    <header className="header">
      {/* Top header */}




       <div className="header-top bg-darkk pt-md-2">
        <div className="container">
          <div className="row justify-content-center justify-content-xl-between align-items-center">
            <div className="col-auto">
              <div className="header-top-contact">
                <ul className='anchor d-md-flex '>
                  <li className='px-md-5 fw-bold'>
                    <a className='text-white' href="tel:+919209169761 fw-bold">
                      <i className="fas fa-phone-volume  "></i> +91 9209169761
                    </a>
                  </li>
                  <li className='px-md-5 fw-bold'>
                    <a className='text-white' href="tel:+919096665072 fw-bold">
                      <i className="fas fa-phone-volume  "></i> +91 9096665072
                    </a>
                  </li>
                  <li>
                    <a className='text-white' href="mailto:reservation@swamisamarthpg.com">
                      <i className="far fa-envelope  "></i>
                      <span className='text-white fw-bold emailfont'> reservation@swamisamarthpg.com</span>
                    </a>
                  </li>

                 
                </ul>


              </div>
            </div>

          </div>
        </div>
      </div>

      {/* Main Navigation */}
      <div className="main-navigation">
        <Navbar expand="lg">
          <Container>
            <Navbar.Brand as={Link} to="/">
              <img src="./images/logo.png" alt="logo" />
            </Navbar.Brand>

            <Navbar.Toggle aria-controls="main_nav" onClick={toggleNav}>
              <i className="fas fa-bars darkcolor"></i>
            </Navbar.Toggle>

            <Navbar.Collapse id="main_nav" className={isNavOpen ? 'show' : ''}>
              <Nav className="ms-auto">
                <Nav.Link as={Link} to="/" className="fw-bold nav-item">Home</Nav.Link>

                <NavDropdown title="About" id="about-us-dropdown" className="fw-bold">
                  <NavDropdown.Item as={Link} to="/about" className="fw-bold nav-item">About Us</NavDropdown.Item>
                  <NavDropdown.Item as={Link} to="/rules-and-regulations" className="fw-bold nav-item">Rules And Regulations</NavDropdown.Item>
                  <NavDropdown.Item as={Link} to="/term-condition" className="fw-bold nav-item">Term & Condition</NavDropdown.Item>
                  <NavDropdown.Item as={Link} to="/privacy-policy" className="fw-bold">Privacy & Policy</NavDropdown.Item>
                </NavDropdown>

                <NavDropdown title="Pg Rooms" id="about-us-dropdown" className="fw-bold">
                  <NavDropdown.Item as={Link} to="/pg-room" className="fw-bold nav-item">Pg Rooms</NavDropdown.Item>
                  <NavDropdown.Item as={Link} to="/gallery" className="fw-bold nav-item">Gallery</NavDropdown.Item>
                </NavDropdown>

                <Nav.Link as={Link} to="/Services" className="fw-bold nav-item">Services</Nav.Link>

                

               
                <Nav.Link as={Link} to="/Amenities" className="fw-bold nav-item">Amenities</Nav.Link>
                <Nav.Link as={Link} to="/Tariff-Plan" className="fw-bold nav-item">Tariff Plan</Nav.Link>
                <Nav.Link as={Link} to="/Online-Pay" className="fw-bold nav-item">Online Payment</Nav.Link>

                <NavDropdown title="Contact" id="contact-dropdown" className="fw-bold">
                  <NavDropdown.Item as={Link} to="/contact" className="fw-bold nav-item">Contact</NavDropdown.Item>
                  <NavDropdown.Item as={Link} to="/enquiry" className="fw-bold">Enquiry</NavDropdown.Item>
                </NavDropdown>
              </Nav>
            </Navbar.Collapse>
          </Container>
        </Navbar>
      </div>

      {/* Search Area */}
      {isSearchOpen && (
        <div className="search-area">
          <form action="#">
            <div className="form-group">
              <input type="text" className="form-control" placeholder="Type Keyword..." />
              <button type="submit" className="search-icon-btn">
                <i className="far fa-search"></i>
              </button>
            </div>
          </form>
        </div>
      )}
    </header>
  );
};

export default Header;
